export default __webpack_public_path__ + "9940ca8298eb9dbfc1c809dce789d943.png";